import { Controller } from 'stimulus';

export default class extends Controller {
  static targets =  ['checkbox', 'button']
  
  toggleButtonState(event) {
    if (event.target.checked == true) {
      this.buttonTarget.classList.remove('btn--disable')
    } else {
      this.buttonTarget.classList.add('btn--disable')
    }
  }
}